import React from 'react';
import ImageElement from './imageElement';
import Video from './video';
import { connect } from 'react-redux';
import Zoom from '../../../utils/animations/zoom';

const mapStateToProps = (state, ownProps) => {
	const {
		rightSectionProps: { instruction },
		leftSectionProps: { videoId, question, imagesrc, liveClassURL, queDesc, questionId },
		isMultiQuestion,
	} = state.rootReducer.testPageDetails;

	const { hideTitle } = ownProps

	return {
		videoId,
		question,
		imagesrc,
		liveClassURL,
		queDesc,
		questionId,
		instruction,
		isMultiQuestion,
		hideTitle,
	};
};

const TopQuestion = ({
	videoId,
	question,
	imagesrc,
	liveClassURL,
	queDesc,
	questionId,
	instruction,
	isMultiQuestion,
	hideTitle
}) => {
	return (
		<section className="quiz-area-question">
			<Zoom
				className="btn btn-icon pull-right pad-no mar-no help-popup-link"
				data-toggle="tooltip"
				data-placement="top"
				title="Help"
			>
				<i
					className="fa fa-question-circle fa-2x"
					data-toggle="modal"
					data-target="#help-popup"
					aria-hidden="true"
				></i>
			</Zoom>

			{!hideTitle && 
				(!!isMultiQuestion ? (
					<h4 dangerouslySetInnerHTML={{ __html: instruction }} />
				) : (
					<h4>{question} </h4>
				))
			}
			<div>
				{(!!queDesc || !!imagesrc || !!videoId) && (
					<div className="paratext">
						{(!!videoId && <Video key={questionId} videoId={videoId} queDesc={queDesc} />) ||
							((!!queDesc || !!imagesrc) && (
								<ImageElement
									imagesrc={imagesrc}
									liveClassURL={liveClassURL}
									queDesc={queDesc}
								/>
							))}
					</div>
				)}
			</div>
		</section>
	);
};

export default connect(mapStateToProps)(TopQuestion);
